export default __webpack_public_path__ + "static/media/dutchgot-mobile-3.ca9c99a5.png";